module.exports = __webpack_public_path__ + "img/360dataqualitydashboard-color.5d5dbb39.svg";